import React from 'react';
import { QualityRulesEditor, QualityRulesHeld } from '../../components/QualityRulesEditor';
import { Setter } from './shared';

// The Quality rules tab of project settings.
// Props-only (refactor plan F6): the ProjectSettings shell owns the state, the
// loads and the handlers, so a tab switch keeps unsaved input. The editor's
// rules and draft are held there too, so leaving the tab keeps an unsaved
// change and coming back does not load the rules again.
interface QualityTabProps {
  projectId: string;
  canEditRules: boolean;
  flash: (msg: string) => void;
  qualityRules: QualityRulesHeld;
  setQualityRules: Setter<QualityRulesHeld>;
}

export const QualityTab: React.FC<QualityTabProps> = ({ projectId, canEditRules, flash, qualityRules, setQualityRules }) => (
  <div className="card" data-help-key="settings.quality">
    <h3>Requirement quality rules</h3>
    <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>
      How this project's requirements are worded and judged. Set nothing and the project
      follows its workspace's house style (Workspace settings → Quality rules); override only
      what this project needs to do differently. Agents read these rules before they draft,
      and the quality badge scores against them.
    </p>
    {projectId && (
      <QualityRulesEditor
        level="project"
        id={projectId}
        canEdit={canEditRules}
        onSaved={() => flash('Quality rules saved')}
        held={qualityRules}
        setHeld={setQualityRules}
      />
    )}
  </div>
);
